export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_04_blank.8052a588.png";